module.exports = __webpack_public_path__ + "img/gla_cover_image.fe4ff51a.jpg";